import { CheckInField } from '../../common/models'
import { http } from './http'

const BASE = '/operations/festivals/friend-profile/custom-fields'

export const getAllCheckInFields = () => http.get<CheckInField[]>(BASE)

export const getCheckInField = (id: string) =>
  http.get<CheckInField>(`${BASE}/${id}`)

export const updateCheckInField = (data: CheckInField) =>
  data.id
    ? http.put<CheckInField>(`${BASE}/${data.id}`, data)
    : http.post<CheckInField>(BASE, data)

export const deleteCheckInField = (ids: string[]) =>
  http.delete<void>(BASE, { data: { ids } })

export const updateCheckInFieldsOrder = (id: string, ordinal: number) =>
  http.patch<void>(`${BASE}/${id}/ordinal`, { ordinal })
